import { Button, Result } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NProgress from "nprogress";

const NotPermission = () => {
  const navigation = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      NProgress.done();
    }, 1000);
  }, []);
  return (
    <div className="flex justify-center items-center min-h-[calc(100vh-200px)] comingSoonCass">
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigation("/")}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default NotPermission;
